import React, { useEffect, useState, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import FilledInput from "@mui/material/FilledInput";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import $ from "jquery";
import axios from "axios";
import API from "../../helpers/endpointService";
import { logoutFunction, Loader } from "./commonFunction";

const PasswordLoginModal = ({
  item,
  passwordValidated,
  passwordFailed,
  moduleName,
}) => {
  const inputRef = useRef(null);
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [isAppLoader, setIsAppLoader] = useState(false);
  const handleClickShowNewPassword = () => setShowNewPassword((show) => !show);

  useEffect(() => {
    resetFields();
  }, []);

  const resetFields = () => {
    $("#password-check").val("");
    $(".password-inputs").removeClass("password-input-valid");
    $("#passwordInvalid").addClass("d-none");
    $("#passwordInvalid").text("");
  };
  const openDocument = () => {
    let API_URL = API.POST_VALIDATE_DOCUMENT_PASSWORD;
    let passwordValue = $("#password-check").val();
    if (passwordValue !== "") {
      setIsAppLoader(true);
      resetFields();
      let obj = {
        documentId: moduleName == "document" ? item.id : item.documentId,
        password: window.btoa(passwordValue),
        userId: localStorage.getItem("UserId"),
      };
      axios
        .post(API_URL, obj)
        .then((response) => {
          if (response?.status === 200) {
            if (response.data == true) {
              document.getElementById("cancelPasswordModal").click();
              passwordValidated();
            } else {
              $(".password-inputs").addClass("password-input-valid");
              $("#passwordInvalid").removeClass("d-none");
              $("#passwordInvalid").text("The provided password is invalid");
              passwordFailed();
            }
            setIsAppLoader(false);
          } else {
            resetFields();
            setIsAppLoader(false);
          }
        })
        .catch((err) => {
          setIsAppLoader(false);
          resetFields();
          logoutFunction(err?.response?.status);
        });
    } else {
      $(".password-inputs").addClass("password-input-valid");
      $("#passwordInvalid").removeClass("d-none");
      $("#passwordInvalid").text("Please enter the document password");
    }
  };

  return (
    <>
      <div
        className="modal fade"
        id="passwordLoginModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content px-4 py-3">
            <div className="modal-header border-0 p-0">
              <div className="row w-100">
                <div className="col-12 d-flex justify-content-between">
                  <div className="text-center">
                    <label className="modal-head-label">Password</label>
                  </div>
                  <CloseIcon
                    className="crossicon-modal"
                    data-bs-dismiss="modal"
                    onClick={() => resetFields()}
                  />
                </div>
              </div>
            </div>
            <div className="modal-body border-0 px-0 py-3">
              <div className="row">
                <div className="col-12">
                  <label className="modal-input-label">
                    Please provide the password to open this document
                  </label>
                  <FormControl variant="outlined" className="w-100 mt-2">
                    <OutlinedInput
                      inputRef={inputRef}
                      id="password-check"
                      className="password-inputs"
                      type={showNewPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowNewPassword}
                            edge="end"
                          >
                            {showNewPassword ? (
                              <VisibilityOff className="eye-password-icon" />
                            ) : (
                              <Visibility className="eye-password-icon" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  <label
                    className="modal-input-label required-color d-none"
                    id="passwordInvalid"
                  ></label>
                </div>
              </div>
            </div>
            <div className="modal-footer border-0 p-0">
              <div className="row w-100">
                <div className="col-12 d-flex justify-content-center gap-2">
                  <button
                    className={`btn btn-light input-group filter-archivekbtn p-2`}
                    onClick={() => openDocument()}
                  >
                    <span className="model-label pl-5">Open</span>
                  </button>
                  <button
                    data-bs-dismiss="modal"
                    className={`btn btn-light input-group filter-backbtn`}
                    onClick={() => resetFields()}
                    id="cancelPasswordModal"
                  >
                    <span className="model-backlabel pl-5">Cancel</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Loader isAppLoader={isAppLoader} />
    </>
  );
};

export default PasswordLoginModal;
